<template>
    <tr>
        <td>{{row.guide.full_name}}</td>
        <td :class="conditional(row.total)">{{row.total}}</td>
        <td :class="conditional(row.b1_19)">{{row.b1_19}}</td>
        <td :class="conditional(row.b20_39)">{{row.b20_39}}</td>
        <td :class="conditional(row.b40_55)">{{row.b40_55}}</td>
        <td :class="conditional(row.b56_59)">{{row.b56_59}}</td>
        <td :class="conditional(row.b60_73)">{{row.b60_73}}</td>
        <td :class="conditional(row.b74)">{{row.b74}}</td>
        <td>--</td>
    </tr>
</template>

<script>
export default {
    props: {
        row: {
            type: Object,
            required: true
        },
        idx: {
            type: Number,
            required: false,
        }
    },
    methods: {
        conditional(value) {
            if ( value > 0 ) {
                return 'font-weight-bold border'
            }
        }
    }
}
</script>